module.exports = __webpack_public_path__ + "static/media/emptyTaskProgress.51b98f5b.svg";